import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";

export function useDeleteReport(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);

  return useMutation<void, Response, number>({
    mutationKey: ["DeleteReport"],
    mutationFn: async (reportId: number) => {
      return await apiContext.utp2ReportsAPIs.deleteReport(reportId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
